import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import parseIsoDate from '../../utils/parseIsoDate';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
  transform(
    value: string | null,
    isNotificationEntityCreation?: boolean,
    isDateTraining?: boolean,
    withLineBreak?: boolean,
  ): string {
    if (!value) return '';

    const date = parseIsoDate(value, { isDateTraining: isDateTraining });

    if (isNotificationEntityCreation) {
      return `${format(date, 'd MMMM', { locale: ru })} ${format(date, 'HH:mm')}`;
    }

    if (isDateTraining) {
      return `${format(date, 'd MMMM', { locale: ru })} ${format(date, 'yyyy')}`;
    }

    if (withLineBreak) {
      return `${format(date, 'd MMM', { locale: ru })}\n${format(date, 'HH:mm')}`.replace('.', '');
    }

    return `${format(date, 'd MMMM', { locale: ru })} в ${format(date, 'HH:mm')}`;
  }
}
